class PageHeaderController {
  constructor($state) {
    "ngInject";
    this.name = 'pageHeader';
    this.state = $state;
  }

  showPageHeader() {
    if(this.state.current.data) {
      return this.state.current.data.pageHeader;
    }
  }

  getBreadcrumbLink(){
    if(this.state.current.data) {
      return this.state.current.data.breadcrumbLink;
    }
  }

  getBreadcrumbText(){
    if(this.state.current.data) {
      return this.state.current.data.breadcrumbText;
    }
  }

  getTitle() {
    if(this.state.current.data) {
      return this.state.current.data.pageTitle;
    }
  }

  getPageDescription() {
    if(this.state.current.data) {
      return this.state.current.data.pageDesc;
    }
  }

  navigateTo() {
    let link = this.getBreadcrumbLink();
    this.state.go(link);
  }

}

export default PageHeaderController;



// WEBPACK FOOTER //
// ./client/common/page-header/page-header.controller.js